import React from 'react';
import { Redirect, useParams } from 'react-router';

const Direct: React.FC = () => {
  const { brandId } = useParams<{ brandId: string }>();
  if (!brandId) {
    <Redirect to="/home" />;
  }
  return (
    <Redirect
      to={`/brand/${brandId}?direct=true${
        location.search ? `${location.search.replace('?', '&')}` : ''
      }`}
    />
  );
};

export default Direct;
